/** Life-sciences API and picker format (`05-Jan-2026`). */
export const LIFE_SCIENCES_DATE_FORMAT = 'DD-MMM-YYYY';
